import { type DeviceFamily, deviceHintFromUserAgent } from '~/utils/device'

// The server's User-Agent guess at the layout family, carried to the client in
// the payload so hydration renders what the server rendered.
export const useDeviceHint = () => useState<DeviceFamily>('device-hint', () =>
  import.meta.server ? deviceHintFromUserAgent(useRequestHeaders(['user-agent'])['user-agent']) : 'desktop'
)
